import { useState, useEffect } from "react";
import { useLiferayLanguage } from "../hooks/useLiferayLanguage";

export const InformeSostenibilidad = ({ informe, index, showFirstOpen }) => {

    const accoridonAriaLabel = useLiferayLanguage("aena.label.expand.collapse.accordion", "Expandir/contraer accordeón");
    const detailsText = useLiferayLanguage("details", "Detalles");

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(showFirstOpen && index === 0);
    }, [showFirstOpen, index]);

     const formatFileSize = (bytes) => {
        if (!bytes) return "0 KB";
            const kb = bytes / 1024;
            return kb >= 1024
                ? `${(kb / 1024).toFixed(1)} MB`
                : `${kb.toFixed(1)} KB`;
     };

    const getMappedInforme = (informe) => {
      const mappedInforme = {};

      if (informe.taxonomyCategoryBriefs?.length) {
        mappedInforme.anio = informe.taxonomyCategoryBriefs[0].taxonomyCategoryName;
      }

      informe.contentFields?.forEach((contentField) => {
        if (contentField.name === "documento") {
          const doc = contentField.contentFieldValue?.document || {};
          mappedInforme.documento = {
            url: doc.contentUrl || "",
            nombre: doc.title || "",
            extension: doc.fileExtension || "",
            tamanio: formatFileSize(doc.sizeInBytes),
          };
        } else if (contentField.name === "descripcion") {
          mappedInforme.descripcion = contentField.contentFieldValue?.data?.trim() || "";
        }
      });

      return mappedInforme;
    };

    const mapped = getMappedInforme(informe);

    return (
        <li
            className={`aena-accordion__item ${isOpen ? "is-open" : ""}`}
            id={`informe_${informe.id}_heading`}
        >
            <>
            <div className="aena-accordion__header">
                <div className="aena-accordion__header-text">
                    <h4>{mapped.anio}</h4>
                </div>

                <div className="aena-accordion__action">
                    <button
                        onClick={() => setIsOpen((prev) => !prev)}
                        aria-expanded={showFirstOpen && index === 0 ? "true" : "false"}
                        aria-controls={`acc-content-${informe.id}`}
                        id={`acc-item-${informe.id}`}
                        className="acc-trigger aena-accordion__button aena-button-icon-only aena-button-icon-only--small aena-button-icon-only--alternative"
                        type="button"
                        aria-label={`${accoridonAriaLabel} ${informe.id}`}

                    >
                        <svg className="aena-sprite" aria-hidden="true" focusable="false">
                            <use href="/o/aena-theme-spritemap/spritemap.svg#digital-flecha-abajo-1"></use>
                        </svg>
                    </button>

                    <span className="aena-accordion__action-label paragraph-semibold-large">{detailsText}</span>
                </div>
            </div>

            <div
                id={`acc-content-${informe.id}`}
                aria-labelledby={`acc-item-${informe.id}`}
                role="region"
                className={`aena-accordion__panel ${isOpen ? "is-open" : ""}`}
            >
                <div className="aena-accordion__content aena-accordion__content--no-gap">
                    <div className="aena-document-card aena-action-card--w-fixed aena-link-accessible-wrapper">
                        <div>
                            <p className="aena-document-card__extension aena-action-card--w-fixed paragraph-regular-small">
                                <svg className="aena-sprite aena-sprite--color-green-aaa" aria-hidden="true" focusable="false">
                                    <use href="/o/aena-theme-spritemap/spritemap.svg#digital-descarga"></use>
                                </svg>
                                {mapped.documento.extension.toUpperCase()} - {mapped.documento.tamanio}
                            </p>

                            {mapped.descripcion && (
                                <a className="aena-document-card__link paragraph-semibold-regular" href={mapped.documento.url} target="_blank">{mapped.descripcion}</a>
                            )}
                        </div>
                    </div>

                </div>
            </div>
            </>
        </li>
    );
};